import React, { useEffect, useState } from "react";
import { api, toast, API_URL, Modal } from "../../../services/common";

const EditLeadModal = ({ open, onClose, lead, refreshLeads }) => {
  const [status, setStatus] = useState("");
  const [notes, setNotes] = useState([]);

  useEffect(() => {
    if (lead) {
      setStatus(lead.status || "");
      setNotes(lead.notes || []);
    }
  }, [lead]);

  const handleNoteChange = (index, value) => {
    const updatedNotes = [...notes];
    updatedNotes[index].note = value;
    setNotes(updatedNotes);
  };

  const addNewNote = () => {
    setNotes([...notes, { note: "", date: new Date().toISOString() }]);
  };

  const handleSubmit = async () => {
    try {
      await api.put(`${API_URL}/common/leads/${lead.id}`, {
        status,
        notes,
      });
      toast.success("Lead updated successfully");
      onClose();
      refreshLeads(); // refetch updated leads
    } catch (error) {
      console.error("Error updating lead:", error);
      toast.error("Failed to update lead");
    }
  };

  return (
    <Modal show={open} onHide={onClose}>
      <div style={{ padding: 20, background: "#fff", borderRadius: 8, width: "100%", maxWidth: 600 }}>
        <h2>Edit Lead</h2>

        <div>
          <label>Status:</label>
          <input
            type="text"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          />
        </div>

        <div>
          <label>Notes:</label>
          {notes.map((item, index) => (
            <div key={index} style={{ marginBottom: 10 }}>
              <textarea
                value={item.note}
                onChange={(e) => handleNoteChange(index, e.target.value)}
                rows={2}
                style={{ width: "100%" }}
              />
              <small>Date: {new Date(item.date).toLocaleString()}</small>
            </div>
          ))}
          <button type="button" onClick={addNewNote}>+ Add Note</button>
        </div>

        <div style={{ marginTop: 20 }}>
          <button onClick={handleSubmit}>Update Lead</button>
          <button onClick={onClose} style={{ marginLeft: 10 }}>Cancel</button>
        </div>
      </div>
    </Modal>
  );
};

export default EditLeadModal;